import { Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { CleverTapConstents } from 'src/app/services/constants';
import { BankDetails, TosterMsgType } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-account-aggregator',
  templateUrl: './account-aggregator.component.html',
  styleUrls: ['./account-aggregator.component.scss']
})
export class AccountAggregatorComponent implements OnDestroy {
  @ViewChild('iframe') iframe!: ElementRef;
  @Output() entityId: EventEmitter<string> = new EventEmitter<string>();

  constructor(private util: UtilService, private route: ActivatedRoute) {

  }
  ngOnDestroy(): void {
    const d:any = document.querySelector('.landing-content');
   d && (d.style.overflow = 'auto') && (d.style.overflowX = 'hidden');
  }

  ngAfterViewInit() {
    const d:any = document.querySelector('.landing-content');
   d && (d.style.overflow = 'hidden');
    window.addEventListener('message', (event) => {
      switch (event.data.status) {
        case 'success':
          this.entityId.emit(event.data.payload.entityId);
          break;
        case 'exit':
          this.util.showToaster('Failed to link bank', TosterMsgType.ERROR);
          this.util.route('home');
          break;
      }
    })
    this.openAccontAggre();
  }
  openAccontAggre() {
    this.util.cleverTapEventCall(CleverTapConstents.add_bank_details,{
      'applicantType':this.util.getCurrentApplicant.mainApplicant !==null && this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
          'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
    });
    this.util.handleRequests('put', this.util.getUrl('loan_bankconnect', [this.util.getCurrentApplicant.id]), {
      "loanId": this.util.loanDetails.loanId,
      "bankConnectRedirectUrl": "http://localhost:4200/bankredirect"
    }).then((url: any) => {
      this.iframe.nativeElement.src = url.content.redirect_url;
    });
  }

}
